import dayjs from "dayjs";

export const initialFilter = {
  filter: {
    start_booking_time: dayjs().startOf("month").format("YYYY-MM-DD"),
    end_booking_time: dayjs().endOf("month").format("YYYY-MM-DD"),
  },
  pageNumber: 0,
  pageSize: 0,
};
